export const arrayFlatMap = (arr: Array<any>) => [].concat(...arr);

export const arrayDistinct = <T>(arr: Array<any>, compare?: (curr: T, prev: T) => boolean) =>
  compare == null
  ? [...new Set(arr)]
  : arr.filter((item, index, arr1) => arr1.findIndex(t => compare(t, item) ) === index);